import script from "./AgentePage.vue?vue&type=script&setup=true&lang=js"
export * from "./AgentePage.vue?vue&type=script&setup=true&lang=js"

import "./AgentePage.vue?vue&type=style&index=0&id=4ea24c63&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ea24c63"]])

export default __exports__